export const permissions = {
  analytics: {
    newUsersView: 'analytics:new-users:view',
  },
  commissions: {
    assignable: 'commissions:assignable',
    assigneesManage: 'commissions:assignees:manage',
    fieldsList: 'commissions:fields:list',
    view: 'commissions:view',
  },
  companies: {
    accountUpdate: 'companies:account:update',
    accountView: 'companies:account:view',
    analyticsView: 'companies:analytics:view',
    changeType: 'companies:change-type',
    contactsCreate: 'companies:contacts:create',
    contactsDelete: 'companies:contacts:delete',
    contactsList: 'companies:contacts:list',
    contactsUpdate: 'companies:contacts:update',
    countersView: 'companies:counters:view',
    create: 'companies:create',
    crossCompanyView: 'companies:cross-company-view',
    delete: 'companies:delete',
    documentsDelete: 'companies:documents:delete',
    documentsList: 'companies:documents:list',
    documentsUpload: 'companies:documents:upload',
    haulierAnalyticsView: 'companies:haulier-analytics:view',
    listByType: 'companies:list-by-type',
    listShippers: 'companies:list-shippers',
    merge: 'companies:merge',
    patronAssignable: 'companies:patron-assignable',
    tagsManage: 'companies:tags:manage',
    tagTypesView: 'companies:tag-types:view',
    update: 'companies:update',
    updateCreditLimit: 'companies:update-credit-limit',
    updateRating: 'companies:update-rating',
    view: 'companies:view',
  },
  config: {
    default: 'config:default',
    defaultAll: 'config:default-all',
    list: 'config:list',
    update: 'config:update',
  },
  customerRiskProfiles: {
    create: 'customer-risk-profiles:create',
    list: 'customer-risk-profiles:list',
    update: 'customer-risk-profiles:update',
    view: 'customer-risk-profiles:view',
  },
  customerSetupForms: {
    create: 'customer-setup-forms:create',
    delete: 'customer-setup-forms:delete',
    list: 'customer-setup-forms:list',
    merge: 'customer-setup-forms:merge',
    tokens: {
      create: 'customer-setup-forms:tokens:create',
      delete: 'customer-setup-forms:tokens:delete',
      list: 'customer-setup-forms:tokens:list',
    },
    update: 'customer-setup-forms:update',
    view: 'customer-setup-forms:view',
  },
  loads: {
    acceptRate: 'loads:accept-rate',
    assignable: 'loads:assignable',
    assigneesAttach: 'loads:assignees:attach',
    assigneesDetach: 'loads:assignees:detach',
    assigneesManage: 'loads:assignees:manage',
    bills: {
      crossOrganisation: 'loads:bills:cross-organisation',
      download: 'loads:bills:download',
      import: 'loads:bills:import',
      remove: 'loads:bills:remove',
      view: 'loads:bills:view',
    },
    bulkCancel: 'loads:bulk:cancel',
    bulkDelete: 'loads:bulk:delete',
    chatsJoin: 'loads:chats:join',
    chatsLeave: 'loads:chats:leave',
    chatsList: 'loads:chats:list',
    chatsMessagesView: 'loads:chats-messages:view',
    commentsCreate: 'loads:comments:create',
    commentsDelete: 'loads:comments:delete',
    commentsList: 'loads:comments:list',
    commentsUpdate: 'loads:comments:update',
    commentsView: 'loads:comments:view',
    create: 'loads:create',
    createDraft: 'loads:create-draft',
    crossUserView: 'loads:cross-user-view',
    customsManage: 'loads:customs:manage',
    delete: 'loads:delete',
    drops: {
      documents: {
        internal: {
          create: 'loads:drops:documents:internal:create',
          delete: 'loads:drops:documents:internal:delete',
          list: 'loads:drops:documents:internal:list',
          manageNotes: 'loads:drops:documents:internal:manage-notes',
          view: 'loads:drops:documents:internal:view',
          viewNotes: 'loads:drops:documents:internal:view-notes',
        },
        public: {
          create: 'loads:drops:documents:public:create',
          delete: 'loads:drops:documents:public:delete',
          list: 'loads:drops:documents:public:list',
          view: 'loads:drops:documents:public:view',
        },
      },
    },
    endCarrier: {
      manage: 'loads:end-carrier:manage',
    },
    endCustomer: {
      manage: 'loads:end-customer:manage',
    },
    estimatedCostsManage: 'loads:estimated-costs:manage',
    estimatedCostsRemove: 'loads:estimated-costs:remove',
    estimatedCostsView: 'loads:estimated-costs:view',
    financialsDelete: 'loads:financials:delete',
    financialsManage: 'loads:financials:manage',
    financialsView: 'loads:financials:view',
    flagsCreate: 'loads:flags:create',
    flagsDelete: 'loads:flags:delete',
    flagsList: 'loads:flags:list',
    flagsUpdate: 'loads:flags:update',
    flagsView: 'loads:flags:view',
    flagTypesList: 'loads:flag-types:list',
    flagTypesView: 'loads:flag-types:view',
    haulierManage: 'loads:haulier:manage',
    historyView: 'loads:history:view',
    issuesCreate: 'loads:issues:create',
    list: 'loads:list',
    listForHaulier: 'loads:list-for-haulier',
    listForPartner: 'loads:list-for-partner',
    listForShipper: 'loads:list-for-shipper',
    orderConfirmationsCreate: 'loads:order-confirmations:create',
    orderConfirmationsDelete: 'loads:order-confirmations:delete',
    orderConfirmationsList: 'loads:order-confirmations:list',
    orderConfirmationsView: 'loads:order-confirmations:view',
    paymentTagsManage: 'loads:payment-tags:manage',
    paymentTagTypesView: 'loads:payment-tag-types:view',
    publishDraft: 'loads:publish-draft',
    tagTypesDelete: 'loads:tag-types:delete',
    tagTypesView: 'loads:tag-types:view',
    totalsView: 'loads:totals:view',
    update: 'loads:update',
    updateDrop: 'loads:update-drop',
    updateDropPastDates: 'loads:update-drop-past-dates',
    updateStatus: 'loads:update-status',
    userChatsView: 'loads:user-chats:view',
    view: 'loads:view',
    xeroInvoicesConnect: 'loads:xero-invoices:connect',
    xeroInvoicesCreate: 'loads:xero-invoices:create',
    xeroInvoicesDownload: 'loads:xero-invoices:download',
    xeroInvoicesRemove: 'loads:xero-invoices:remove',
    xeroInvoicesView: 'loads:xero-invoices:view',
    xeroQuotesConnect: 'loads:xero-quotes:connect',
    xeroQuotesCreate: 'loads:xero-quotes:create',
    xeroQuotesDownload: 'loads:xero-quotes:download',
    xeroQuotesRemove: 'loads:xero-quotes:remove',
    xeroQuotesView: 'loads:xero-quotes:view',
  },
  locations: {
    create: 'locations:create',
    delete: 'locations:delete',
    list: 'locations:list',
    update: 'locations:update',
    view: 'locations:view',
  },
  organisations: {
    list: 'organisations:list',
    xeroConnectionTest: 'organisations:xero-connection:test',
    xeroConnectionUpdate: 'organisations:xero-connection:update',
    xeroConnectionView: 'organisations:xero-connection:view',
  },
  permissionGroups: {
    attachPermissions: 'permission-groups:attach-permissions',
    create: 'permission-groups:create',
    delete: 'permission-groups:delete',
    detachPermissions: 'permission-groups:detach-permissions',
    list: 'permission-groups:list',
    update: 'permission-groups:update',
    view: 'permission-groups:view',
  },
  public: {
    loadTypesView: 'public:load-types:view',
    packagingTypesView: 'public:packaging-types:view',
  },
  reports: {
    commissionCreate: 'reports:commission:create',
    commissionDownload: 'reports:commission:download',
    commissionView: 'reports:commission:view',
    loadsDataCreate: 'reports:loads-data:create',
    loadsDataDownload: 'reports:loads-data:download',
    loadsDataView: 'reports:loads-data:view',
  },
  roles: {
    list: 'roles:list',
  },
  trucks: {
    create: 'trucks:create',
    delete: 'trucks:delete',
    postedTrucks: {
      create: 'trucks:posted-trucks:create',
      delete: 'trucks:posted-trucks:delete',
      list: 'trucks:posted-trucks:list',
      post: 'trucks:posted-trucks:post',
      update: 'trucks:posted-trucks:update',
      view: 'trucks:posted-trucks:view',
    },
    update: 'trucks:update',
    view: 'trucks:view',
  },
  users: {
    adminList: 'users:admin:list',
    countersView: 'users:counters:view',
    create: 'users:create',
    crossUserView: 'users:cross-user-view',
    delete: 'users:delete',
    getAuthToken: 'users:get-auth-token',
    impersonate: 'users:impersonate',
    list: 'users:list',
    permissionsManage: 'users:permissions:manage',
    resendAuthToken: 'users:resend-auth-token',
    superAdminList: 'users:super-admin:list',
    update: 'users:update',
    updatePassword: 'users:update-password',
    updateStatus: 'users:update-status',
    view: 'users:view',
  },
  xero: {
    companyExport: 'xero:company:export',
    companyLink: 'xero:company:link',
    companySync: 'xero:company:sync',
    companyUnlink: 'xero:company:unlink',
    contactView: 'xero:contact:view',
  },
} as const

type LeafValues<T> = T extends string
  ? T
  : T extends PermissionTree
    ? LeafValues<T[keyof T]>
    : never

type PermissionTree = {
  readonly [key: string]: PermissionTree | string
}

type PermissionTreeValue = PermissionTree[string]

const isPermissionLeaf = (value: PermissionTreeValue): value is string => value === String(value)

const flattenPermissionTree = (tree: PermissionTree): string[] => {
  return Object.values(tree).flatMap(value =>
    isPermissionLeaf(value) ? [value] : flattenPermissionTree(value),
  )
}

export const allPermissions =
  /* SAFETY: flattenPermissionTree visits every string leaf in the readonly permission tree. */ flattenPermissionTree(
    permissions,
  ) as Array<LeafValues<typeof permissions>>

const permissionSet = new Set<string>(allPermissions)

export type Permission = LeafValues<typeof permissions>

export const isPermission = (value: string): value is Permission => permissionSet.has(value)
